import { render, staticRenderFns } from "./morePopper.vue?vue&type=template&id=6f924ce2&scoped=true"
import script from "./morePopper.vue?vue&type=script&lang=js"
export * from "./morePopper.vue?vue&type=script&lang=js"
import style0 from "./morePopper.vue?vue&type=style&index=0&id=6f924ce2&prod&lang=scss&scoped=true"
import style1 from "./morePopper.vue?vue&type=style&index=1&id=6f924ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f924ce2",
  null
  
)

export default component.exports